<div
  class="product-card"
  *ngIf="data"
  [ngClass]="{'is-disable': isDisabled$ | async}"
  appObserver
  (leaveEnd)="onAppear()"
>
  <div class="product-card__photo">
    <div class="product-card__img">
      <picture class="cover-picture" *ngIf="currentSize.buttonImage['src']; else photoPlaceholder">
        <source srcset="{{ currentSize.buttonImage['254x196x100.webp'] }}, {{ currentSize.buttonImage['376x276x100.webp'] }} 1.5x, {{ currentSize.buttonImage['508x392x100.webp'] }} 2x">
        <img ngSrc="{{ currentSize.buttonImage['src'] }}" loading="auto" [alt]="data.name" alt="" width="200" height="100" appPictureFallback>
      </picture>
    </div>

    <div class="product-card__tags" *ngIf="data.labels && !!data.labels.length">
      <div class="tag-list">
        <ng-container *ngFor="let label of data.labels">
          <div class="tag" (click)="setLabelFilter(label.name)">{{ label.name }}</div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="product-card__body">
    <ng-container *ngIf="!isHidePrice">
      <ng-container *ngIf="currentSize && defaultPrice$ | async as defaultPrice">
        <div class="product-card__price h2">
          <app-product-price [price]="defaultPrice"></app-product-price>
        </div>
      </ng-container>
    </ng-container>

    <div class="product-card__title h3">{{ data.name }}</div>

    <div class="product-card__caption" *ngIf="data.description">{{ data.description }}</div>

    <ng-container *ngIf="data.itemSizes">
      <div class="product-card__bottom">
        <div class="product-card__portion" *ngIf="currentSize.portionWeightGrams || energy">
          <ng-container *ngIf="currentSize.portionWeightGrams">
            <div class="product-card__weight">
              <app-product-unit
                *ngIf="currentSize.portionWeightGrams"
                [unit]="currentSize.measureUnitType"
                [value]="currentSize.portionWeightGrams"
              ></app-product-unit>
            </div>
          </ng-container>

          <ng-container *ngIf="energy">
            <div class="product-card__energy">
              {{ energy | number: '1.0-0' }} <span i18n="@@EnergyUnit">kcal</span>
            </div>
          </ng-container>
        </div>

        <div class="product-card__ctrl" *ngIf="(isBasketMode$ | async) && !isLock">
          <div class="product-card__counter" *ngIf="isShowCounter$ | async" [formGroup]="form">
            <app-counter
              *ngIf="basketItem$ | async as basketItem"
              [min]="0"
              [max]="data.balance ?? 10000"
              [isDisabled]="data.balance === 0"
              formControlName="counter"
              (changeValue)="onChangeCount(basketItem.itemKey, $event)"
            ></app-counter>
          </div>

          <button type="button" class="product-card__button button button--th-main _rounded _sm"
            (click)="onAddToBasket(data.balance && data.balance < 0 ? null : data.slug)"
            [disabled]="data.balance === 0"
            *ngIf="(isShowCounter$ | async) === false"
          >
            <span class="button__text" i18n="@@AddToBasket">Add</span>
            <i class="button__icon icomoon icomoon--cart"></i>
            <div class="button__spinner">
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
          </button>

        </div>
      </div>
    </ng-container>
  </div>
  <a class="product-card__link" (click)="onOpenCard(data.balance && data.balance < 0 ? null : data.slug)"></a>
</div>

<ng-template #photoPlaceholder>
  <i class="icomoon icomoon--dish-placeholder"></i>
</ng-template>
